// ======================================================================
// File Name       : box
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { hasProperty } from '../utils';
import * as courseUtils from '../utils/CourseUtils';
import * as ActionTypes from '../constants/actionTypes/box';
import { MODE, PUBLIC } from '../constants';
import { END_CONDITION_TYPE_FOR_BOX, CHOSEN_THUMBNAIL_BOX } from '../constants/BoxConstants';


const INITIAL_BOX = {
  boxSecernId: '',
  boxName: '',
  parentCourseSecernId: null,
  parentBoxSecernId: null,
  description: '',
  publicStatus: PUBLIC,
  endConditionTypeForBox: END_CONDITION_TYPE_FOR_BOX.ALL_ITEM_COMPLETED, // Step 10.2.0
  progressRatioForBoxEnd: null,
  itemListForBoxEnd: [],
  imageFileSelectType: CHOSEN_THUMBNAIL_BOX.DEFAULT,
  // sprint_20230522_tma START
  startConditionTypeForBox: END_CONDITION_TYPE_FOR_BOX.NONE,
  progressRatioForBoxStart: 0,
  selectedItemList: [],
  // sprint_20230522_tma END
};

const INITIAL_STATE = {
  boxs: {
    bySecernId: {},
    allSecernIds: [],
  },
  editType: MODE.EDIT_MODE,
  editingBox: {},
  childItemSercernIdList: [],
};

export default function course(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.BOX_INIT_DATA_FOR_DETAIL_EDIT_CONFIRM_DIALOG:
      return initDataForDetailEditConfirmDialog(state, action);

    case ActionTypes.BOX_INIT_DATA_FOR_REGISTER_DIALOG:
      return initDataForRegisterDialog(state, action);

    case ActionTypes.BOX_RECEIVE_BOX_LIST:
      return receiveBoxList(state, action);

    case ActionTypes.BOX_INPUT_CHANGE:
      return changeEditingData(state, action);

    case ActionTypes.BOX_CHANGE_DATA:
      return changeData(state);

    case ActionTypes.BOX_GET_THUMBNAIL_DEFAULT:
      return getThumbnailDefault(state, action);

    case ActionTypes.BOX_SAVE_DETAIL_SETTING_STATE:
      return saveDetailSettingState(state, action);

    default:
      return state;
  }
}

function initDataForDetailEditConfirmDialog(state, action) {
  const { boxSecernId, childItemSercernIdList } = action;
  const { boxs: { bySecernId } } = state;
  // sprint_20230522_tma START
  const selectedItemList = [];
  // sprint_20230522_tma END
  const { detailSettingExpanded, userAttributeExpanded } = INITIAL_STATE;
  if (bySecernId && bySecernId[boxSecernId]) {
    // sprint_20230522_tma START
    const { itemListForBoxStart } = bySecernId[boxSecernId];
    for (let i = 0; i < itemListForBoxStart.length; i++) {
      const newItemList = {
        itemSecernId: itemListForBoxStart[i],
        addNew: true,
      };
      selectedItemList.unshift(newItemList);
    }
    // sprint_20230522_tma END
    const editingBox = {
      ...state.editingBox,
      ...state.boxs.bySecernId[boxSecernId],
      imageFileSelectType: CHOSEN_THUMBNAIL_BOX.NOTHING,
      imageUploadFile: null,
    };
    return {
      ...state,
      editingBox,
      editType: MODE.EDIT_MODE,
      childItemSercernIdList,
      selectedItemList, // sprint_20230522_tma
      detailSettingExpanded,
      userAttributeExpanded,
    };
  }
  return {
    ...state,
  };
}

function receiveBoxList(state, action) {
  const { recordNum, boxList } = action;
  const boxs = boxList.reduce(
    (acc, cur) => {
      const { boxSecernId } = cur;
      const { bySecernId, allSecernIds } = acc;

      const notExistBoxSecernId = !hasProperty(bySecernId, boxSecernId);
      notExistBoxSecernId && allSecernIds.push(boxSecernId);
      bySecernId[boxSecernId] = cur;
      return acc;
    },
    {
      ...state.boxs,
    },
  );

  return {
    ...state,
    ...{ boxs },
  };
}

function changeEditingData(state, action) {
  const { payload } = action;
  const { name, value } = payload;
  const editingBox = { ...state.editingBox, ...payload };
  return {
    ...state,
    editingBox,
  };
}

function initDataForRegisterDialog(state, action) {
  const { boxSecernId } = action;
  const editingBox = {
    ...INITIAL_BOX,
    boxSecernId,
  };
  const { detailSettingExpanded, userAttributeExpanded } = INITIAL_STATE;

  return {
    ...state,
    editingBox,
    editType: MODE.NEW_MODE,
    detailSettingExpanded,
    userAttributeExpanded,
  };
}

function changeData(state) {
  const { boxs } = state;
  const { bySecernId } = boxs;
  try {
    const boxSecernId = state.editingBox.boxSecernId;
    let thumbnailUrl = null;
    if (bySecernId && bySecernId[boxSecernId] && bySecernId[boxSecernId].thumbnailUrl) {
      if (state.editingBox.imageFileSelectType === CHOSEN_THUMBNAIL_BOX.NOTHING) {
        thumbnailUrl = bySecernId[boxSecernId].thumbnailUrl;
      }
    }
    const editingBox = {
      ...state.editingBox,
      thumbnailUrl,
    };
    return {
      ...state,
      editingBox,
    };
  } catch (err) {
    return err;
  }
}

function getThumbnailDefault(state, action) {
  const { data } = action;
  let defaultThumbnail = null;
  try {
    if (data && data.imageList && data.imageList.length && data.imageList[0].thumbnailUrl) {
      defaultThumbnail = data.imageList[0].thumbnailUrl;
    }
  } catch (err) {
    return err;
  }
  const editingBox = {
    ...state.editingBox,
    defaultThumbnail,
  };
  return {
    ...state,
    editingBox,
  };
}

function saveDetailSettingState(state, action) {
  const { name, value } = action;
  return {
    ...state,
    [name]: value,
  };
}
